import { BaseModel } from '../classes/query-builder.class';

export class Survey extends BaseModel {
  public table = 'surveys';
  public schema = {
    id: 'INTEGER PRIMARY KEY AUTOINCREMENT',
    hashed_id: 'VARCHAR',
    assignment_id: 'VARCHAR',
    site_id: 'VARCHAR',
    user_id: 'VARCHAR',
    number: 'VARCHAR',
    report_number: 'VARCHAR',
    archived: 'INTEGER',
    status: 'INTEGER',
    survey_type: 'INTEGER',
    commissioner: 'VARCHAR',
    date_from: 'VARCHAR',
    date_to: 'VARCHAR',
    site_photo: 'VARCHAR',
    site_plan: 'VARCHAR',
    certificate: 'VARCHAR',
    purpose: 'VARCHAR',
    address: 'VARCHAR',
    building_type: 'INTEGER',
    building_usage: 'VARCHAR',
    construction_date: 'VARCHAR',
    construction_type: 'VARCHAR',
    scopes_agreed: 'INTEGER',
    scope: 'VARCHAR',
    areas_description: 'LONGTEXT',
    exclusions: 'VARCHAR',
    deviations: 'INTEGER',
    deviations_description: 'LONGTEXT',
    reported_to_client: 'INTEGER',
    completed_at: 'DATETIME',
    synced_at: 'DATETIME',
  };
}
